import { SUCCESS, FAILED, REQUEST } from 'crom-api-constants'

export const INITIALIZE_GROUP_MONITORING = 'INITIALIZE_GROUP_MONITORING'

export const INITIALIZE_GROUP_MONITORING_DIALOG = `${INITIALIZE_GROUP_MONITORING}_DIALOG`

export const INITIALIZE_GROUP_MONITORING_REQUEST = `${INITIALIZE_GROUP_MONITORING}_${REQUEST}`
export const INITIALIZE_GROUP_MONITORING_REQUEST_SUCCESS = `${INITIALIZE_GROUP_MONITORING}_${REQUEST}_${SUCCESS}`
export const INITIALIZE_GROUP_MONITORING_REQUEST_FAILED = `${INITIALIZE_GROUP_MONITORING}_${REQUEST}_${FAILED}`

export const GROUP_MONITORING_DATA = 'GROUP_MONITORING_DATA'
export const GROUP_MONITORING_DATA_REQUEST = `${GROUP_MONITORING_DATA}_${REQUEST}`
export const GROUP_MONITORING_DATA_REQUEST_SUCCESS = `${GROUP_MONITORING_DATA}_${REQUEST}_${SUCCESS}`
export const GROUP_MONITORING_DATA_REQUEST_FAILED = `${GROUP_MONITORING_DATA}_${REQUEST}_${FAILED}`

export const UPDATE_GROUP_MONITORING_REQUEST = `UPDATE_GROUP_MONITORING_${REQUEST}`
export const UPDATE_GROUP_MONITORING_REQUEST_SUCCESS = `UPDATE_GROUP_MONITORING_${REQUEST}_${SUCCESS}`
export const UPDATE_GROUP_MONITORING_REQUEST_FAILED = `UPDATE_GROUP_MONITORING_${REQUEST}_${FAILED}`

export const ADD_GROUP_MONITORING = 'ADD_GROUP_MONITORING'
export const REMOVE_GROUP_MONITORING = 'REMOVE_GROUP_MONITORING'

export const LOCALE_PREFIX = 'components.Dialog.components.GroupMonitoring'

export const GROUPS_LOADED = 'GROUPS_LOADED'
export const LOAD_GROUPS_REQUEST_FAILED = `LOAD_GROUPS_${REQUEST}_${FAILED}`

export const TEXT_ID = 'deleteGroupMonitoring'
